














import type { OpdrachtVolumes } from "../../types/opdrachten/OpdrachtVolumes";

import Vue from "vue";

export default Vue.extend({
    name: "PeriodeMetOpdrachtenVolumes",
    props: {
        opdrachtVolumes: {
            type: Object as () => OpdrachtVolumes,
            required: true
        }
    },
});
